import {ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation} from "@angular/core"
import {CurrentUserStore} from "app/common/services/current-user/CurrentUserStore"
import {FormControl, FormGroup, Validators} from "@angular/forms"
import {Router} from "@angular/router"
import {Observable, of, Subject} from "rxjs"
import {catchError, filter, takeUntil} from "rxjs/operators"
import {isNotNull} from "app/common/util/UtilFunctions"
import {HttpErrorResponse} from "@angular/common/http"

@Component({
    selector: "iinvest-login-page",
    templateUrl: "./LoginPageComponent.html",
    styleUrls: ["./LoginPageComponent.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class LoginPageComponent implements OnInit, OnDestroy {

    public email: FormControl
    public password: FormControl
    public form: FormGroup

    public formError: string | null = null;

    private destroyed$ = new Subject<void>()

    public constructor(private store: CurrentUserStore, private router: Router) {

    }

    public ngOnInit(): void {
        this.email = new FormControl(null, Validators.required)
        this.password = new FormControl(null, Validators.required)
        this.form = new FormGroup({
            email: this.email,
            password: this.password
        })
        this.store
            .currentUser
            .pipe(takeUntil(this.destroyed$))
            .pipe(filter(isNotNull))
            .subscribe(() => this.router.navigateByUrl(""))
        this.form
            .valueChanges
            .pipe(takeUntil(this.destroyed$))
            .subscribe(() => this.formError = null)
    }

    public login() {
        if (this.form.valid) {
            this.formError = null;
            this.store
                .logIn(this.email.value, this.password.value)
                .pipe(catchError((err) => this.handleRequestFail(err)))
                .subscribe()
        }
    }

    private handleRequestFail(response: HttpErrorResponse): Observable<void> {
        if (response.status === 401) {
            this.formError = "Username or Password Incorrect"
        } else  {
            this.formError = "There was an unexpected error while attempting to login"
        }
        return of()
    }

    public get hasFormError(): boolean {
        return this.formError != null
    }

    public ngOnDestroy(): void {
        this.destroyed$.next()
        this.destroyed$.complete()
    }
}
